import { ShipmentStatusModel } from "../apiModels/shipmentStatusModel";
import ShipmentUpdateCreateEditForm from "./ShipmentUpdateCreateEditForm";

interface ShipmentUpdateCreateFormProps {
    shipmentTrackingNumber: string | undefined;
    shipmentStatuses: ShipmentStatusModel[];
    description: string;
    setDescription: (description: string) => void;
    location: string;
    setLocation: (location: string) => void;
    statusId: number;
    setStatusId: (statusId: number) => void;
    updateTime: Date | null;
    setUpdateTime: (updateTime: Date | null) => void;
}

export default function ShipmentUpdateCreateForm(props: ShipmentUpdateCreateFormProps) {
    return (<>
        <div className="row">
            <h3 className="col-12">Add Shipment Status Update</h3>
        </div>
        <div className="row">
            <div className="col-12">
                <ShipmentUpdateCreateEditForm description={props.description}
                    setDescription={props.setDescription}
                    location={props.location}
                    setLocation={props.setLocation}
                    statusId={props.statusId}
                    setStatusId={props.setStatusId}
                    updateTime={props.updateTime}
                    setUpdateTime={props.setUpdateTime}
                    statuses={props.shipmentStatuses} />
            </div>
        </div>
    </>);
};